import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { formHeaderTitleSx, formHeaderDescriptionSx } from '../../styles';

export default function FormHeader() {
  const { t } = useTranslation();

  return (
    <Grid item xs={12}>
      <Typography variant='h6' sx={formHeaderTitleSx}>
        {t('inventory.inventoryValuationSettings.valuationCard.title')}
      </Typography>
      <Typography variant='body2' color='textSecondary' sx={formHeaderDescriptionSx}>
        {t('inventory.inventoryValuationSettings.valuationCard.description')}
      </Typography>
    </Grid>
  );
}
